var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#333;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M58.78778,46.02268c4.8457-4.8457,4.8457-12.72992,0-17.57556s-12.73035-4.84613-17.57605-.00049c-4.84558,4.8457-4.84558,12.7309,.00012,17.57654,4.84558,4.8457,12.73022,4.84515,17.57593-.00049Zm-12.61963-12.61951c3.27454-3.27448,7.65759-4.21985,9.77039-2.10706,2.11255,2.11255,1.16711,6.49561-2.1073,9.77008-3.2749,3.2749-7.65796,4.22028-9.77051,2.10773-2.11279-2.11279-1.16748-6.49585,2.10742-9.77075Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M49.99969,54.2064c-9.08276,0-17.23438,3.96973-22.82764,10.26416v8.7168h45.65588v-8.71631c-5.59326-6.29443-13.74524-10.26465-22.82825-10.26465Zm-16.1394,14.95166c3.63086-6.61414,9.50195-10.92236,16.1394-10.92236s12.50842,4.30823,16.13916,10.92236H33.86029Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.c72b39a6eae94eda09c4e447b2ca00f0.svg";
export { ForwardRef as ReactComponent };